export const translations = {
  en: {
    // Auth Page
    appName: 'Promptify Master',
    authSubtitle: 'Transform your lazy prompts into professional masterpieces',
    login: 'Login',
    signUp: 'Sign Up',
    name: 'Name',
    email: 'Email',
    password: 'Password',
    enterName: 'Enter your name',
    enterEmail: 'Enter your email',
    enterPassword: 'Enter your password',
    createAccount: 'Create Account',
    pleaseWait: 'Please wait...',

    // Dashboard
    newPrompt: 'New Prompt',
    history: 'History',
    logout: 'Logout',
    adminPanel: 'Admin Panel',
    landingTitle: 'Turn your lazy prompts into great ones',
    landingSubtitle: 'Get professional prompt results in seconds with AI-powered improvement',
    dark: 'Dark',
    white: 'White',
    terminal: 'Terminal',
    noPromptsYet: 'No prompts yet',
    
    // Prompt Types
    standardPrompt: 'Standard Prompt',
    standardDesc: 'Recommended for most tasks',
    reasoningPrompt: 'Reasoning Prompt',
    reasoningDesc: 'For reasoning tasks (GPT-5 model)',
    deepResearchPrompt: 'Deep Research Prompt',
    deepResearchDesc: 'For web-based research',
    customGptPrompt: 'Custom GPT/Agent Prompt',
    customGptDesc: 'Design your own Custom GPTs or AI Agents',
    veo3Prompt: 'VEO-3 Video Prompt',
    veo3Desc: 'Create prompts for VEO-3 video generation',
    
    // Prompt Actions
    promptPlaceholder: 'Enter your prompt here... e.g., "Write a blog post about AI"',
    improvePrompt: 'Improve Prompt',
    improving: 'Improving...',
    improvedPrompt: 'Improved Prompt',
    copy: 'Copy',
    copied: 'Copied!',
    
    // Subscription
    free: 'free',
    standard: 'standard',
    premium: 'premium',
    upgradeYourPlan: 'Upgrade Your Plan',
    dailyLimitReached: "You've reached your daily limit. Upgrade to continue!",
    standardPlan: 'Standard',
    premiumPlan: 'Premium',
    monthlyPrice: '/month',
    promptsPerDay: 'prompts/day',
    allPromptTypes: 'All prompt types',
    prioritySupport: 'Priority support',
    unlimitedPrompts: 'Unlimited prompts',
    priorityProcessing: 'Priority processing',
    apiAccess: 'API access',
    upgradeTo: 'Upgrade to',
    processing: 'Processing...',
    
    // Admin Panel
    userManagement: 'User Management',
    promptTypes: 'Prompt Types',
    paymentSettings: 'Payment Settings',
    siteSettings: 'Site Settings',
    themeSettings: 'Theme Settings',
    backToDashboard: 'Back to Dashboard',
    admin: 'Admin',
    
    // User Management
    manageUsers: 'Manage user accounts and subscriptions',
    role: 'Role',
    subscription: 'Subscription',
    status: 'Status',
    actions: 'Actions',
    enable: 'Enable',
    disable: 'Disable',
    active: 'active',
    disabled: 'disabled',
    user: 'user',
    
    // Prompt Types Management
    editPromptTypes: 'Edit prompt type titles and descriptions',
    systemInstructions: 'System instructions...',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    
    // Payment Settings
    configurePayment: 'Configure payment providers and modes',
    mode: 'Mode',
    sandbox: 'Sandbox',
    production: 'Production',
    enabled: 'Enabled',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    webhookSecret: 'Webhook Secret',
    configure: 'Configure',
    notSet: 'Not set',
    enterApiKey: 'Enter API key',
    enterApiSecret: 'Enter API secret',
    enterWebhookSecret: 'Enter webhook secret',
    
    // Site Settings
    editSiteSettings: 'Edit site title and landing page content',
    generalSettings: 'General Settings',
    siteTitle: 'Site Title',
    siteDescription: 'Site Description',
    landingPageContent: 'Landing Page Content',
    landingTitleLabel: 'Landing Title',
    landingSubtitleLabel: 'Landing Subtitle',
    saveAllChanges: 'Save All Changes',
    
    // Theme Settings
    chooseTheme: 'Choose the application theme',
    darkTheme: 'Dark Theme',
    darkThemeDesc: 'Modern dark interface with cyan accents',
    whiteTheme: 'White Theme',
    whiteThemeDesc: 'Clean light interface with blue accents',
    terminalTheme: 'Terminal Theme',
    terminalThemeDesc: 'Classic terminal with green text on black',
    
    // Payment Success
    processingPayment: 'Processing Payment...',
    verifyingPayment: 'Please wait while we verify your payment',
    paymentSuccessful: 'Payment Successful!',
    subscriptionActivated: 'Your subscription has been activated successfully',
    continueToDashboard: 'Continue to Dashboard',
    paymentFailed: 'Payment Failed',
    paymentFailedMessage: "We couldn't verify your payment. Please contact support if money was deducted.",
    returnToDashboard: 'Return to Dashboard',
    
    // Language
    language: 'Language',
    english: 'English',
    spanish: 'Spanish',
    
    // Delete
    deletePrompt: 'Delete',
    deleteConfirm: 'Are you sure you want to delete this prompt from history?',
  },
  
  es: {
    // Auth Page
    appName: 'Promptify Master',
    authSubtitle: 'Transforma tus prompts simples en obras maestras profesionales',
    login: 'Iniciar Sesión',
    signUp: 'Registrarse',
    name: 'Nombre',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    enterName: 'Ingresa tu nombre',
    enterEmail: 'Ingresa tu correo',
    enterPassword: 'Ingresa tu contraseña',
    createAccount: 'Crear Cuenta',
    pleaseWait: 'Por favor espera...',

    // Dashboard
    newPrompt: 'Nuevo Prompt',
    history: 'Historial',
    logout: 'Cerrar Sesión',
    adminPanel: 'Panel de Admin',
    landingTitle: 'Convierte tus prompts simples en excelentes',
    landingSubtitle: 'Obtén resultados profesionales en segundos con mejora impulsada por IA',
    dark: 'Oscuro',
    white: 'Claro',
    terminal: 'Terminal',
    noPromptsYet: 'Sin prompts aún',
    
    // Prompt Types
    standardPrompt: 'Prompt Estándar',
    standardDesc: 'Recomendado para la mayoría de tareas',
    reasoningPrompt: 'Prompt de Razonamiento',
    reasoningDesc: 'Para tareas de razonamiento (modelo GPT-5)',
    deepResearchPrompt: 'Prompt de Investigación Profunda',
    deepResearchDesc: 'Para investigación basada en web',
    customGptPrompt: 'Prompt de GPT/Agente Personalizado',
    customGptDesc: 'Diseña tus propios GPTs o Agentes de IA',
    veo3Prompt: 'Prompt de Video VEO-3',
    veo3Desc: 'Crea prompts para generación de video VEO-3',
    
    // Prompt Actions
    promptPlaceholder: 'Ingresa tu prompt aquí... ej., "Escribe un artículo sobre IA"',
    improvePrompt: 'Mejorar Prompt',
    improving: 'Mejorando...',
    improvedPrompt: 'Prompt Mejorado',
    copy: 'Copiar',
    copied: '¡Copiado!',
    
    // Subscription
    free: 'gratis',
    standard: 'estándar',
    premium: 'premium',
    upgradeYourPlan: 'Mejora Tu Plan',
    dailyLimitReached: 'Has alcanzado tu límite diario. ¡Mejora para continuar!',
    standardPlan: 'Estándar',
    premiumPlan: 'Premium',
    monthlyPrice: '/mes',
    promptsPerDay: 'prompts/día',
    allPromptTypes: 'Todos los tipos de prompts',
    prioritySupport: 'Soporte prioritario',
    unlimitedPrompts: 'Prompts ilimitados',
    priorityProcessing: 'Procesamiento prioritario',
    apiAccess: 'Acceso API',
    upgradeTo: 'Mejorar a',
    processing: 'Procesando...',
    
    // Admin Panel
    userManagement: 'Gestión de Usuarios',
    promptTypes: 'Tipos de Prompts',
    paymentSettings: 'Configuración de Pagos',
    siteSettings: 'Configuración del Sitio',
    themeSettings: 'Configuración de Tema',
    backToDashboard: 'Volver al Panel',
    admin: 'Admin',
    
    // User Management
    manageUsers: 'Administrar cuentas de usuario y suscripciones',
    role: 'Rol',
    subscription: 'Suscripción',
    status: 'Estado',
    actions: 'Acciones',
    enable: 'Activar',
    disable: 'Desactivar',
    active: 'activo',
    disabled: 'desactivado',
    user: 'usuario',
    
    // Prompt Types Management
    editPromptTypes: 'Editar títulos y descripciones de tipos de prompts',
    systemInstructions: 'Instrucciones del sistema...',
    save: 'Guardar',
    cancel: 'Cancelar',
    edit: 'Editar',
    
    // Payment Settings
    configurePayment: 'Configurar proveedores y modos de pago',
    mode: 'Modo',
    sandbox: 'Prueba',
    production: 'Producción',
    enabled: 'Activado',
    apiKey: 'Clave API',
    apiSecret: 'Secreto API',
    webhookSecret: 'Secreto Webhook',
    configure: 'Configurar',
    notSet: 'No configurado',
    enterApiKey: 'Ingresar clave API',
    enterApiSecret: 'Ingresar secreto API',
    enterWebhookSecret: 'Ingresar secreto webhook',
    
    // Site Settings
    editSiteSettings: 'Editar título del sitio y contenido de página principal',
    generalSettings: 'Configuración General',
    siteTitle: 'Título del Sitio',
    siteDescription: 'Descripción del Sitio',
    landingPageContent: 'Contenido de Página Principal',
    landingTitleLabel: 'Título Principal',
    landingSubtitleLabel: 'Subtítulo Principal',
    saveAllChanges: 'Guardar Todos los Cambios',
    
    // Theme Settings
    chooseTheme: 'Elegir el tema de la aplicación',
    darkTheme: 'Tema Oscuro',
    darkThemeDesc: 'Interfaz oscura moderna con acentos cian',
    whiteTheme: 'Tema Claro',
    whiteThemeDesc: 'Interfaz clara y limpia con acentos azules',
    terminalTheme: 'Tema Terminal',
    terminalThemeDesc: 'Terminal clásico con texto verde sobre negro',
    
    // Payment Success
    processingPayment: 'Procesando Pago...',
    verifyingPayment: 'Por favor espera mientras verificamos tu pago',
    paymentSuccessful: '¡Pago Exitoso!',
    subscriptionActivated: 'Tu suscripción ha sido activada exitosamente',
    continueToDashboard: 'Continuar al Panel',
    paymentFailed: 'Pago Fallido',
    paymentFailedMessage: 'No pudimos verificar tu pago. Contacta a soporte si se dedujo dinero.',
    returnToDashboard: 'Volver al Panel',
    
    // Language
    language: 'Idioma',
    english: 'Inglés',
    spanish: 'Español',
    
    // Delete
    deletePrompt: 'Eliminar',
    deleteConfirm: '¿Estás seguro de que quieres eliminar este prompt del historial?',
  }
};

export const getTranslation = (key, lang = 'en') => {
  return translations[lang]?.[key] || translations.en[key] || key;
};
